import { getCurrentDateTime } from "utils/formatar-data";
import { guidEmpty } from "utils/guid-empty";

export class IndicacoesInteracoesPostModel {
    constructor(
        public id: string = guidEmpty(),
        public indicacaoId: string | null = null,
        public responsavelId: string | null = null,
        public tipoInteracao: number = 0,
        public descricao: string = '',
        public dataHora: string = getCurrentDateTime(new Date()),
    ) { }
}